import { Component, OnInit, Inject } from '@angular/core';
import { environment, ConstVariable } from 'src/environments/environment';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpEventType, HttpClient, HttpHeaders } from "@angular/common/http";
import { LookupInfo } from '../../model/lookup.model';
import { GlobalService } from '../../service/global.service';
import { TokenService } from '../../service/token.service';
import { SectionInfo } from '../../model/SectionInfo.model';


@Component({
  selector: 'app-Section',
  templateUrl: './section.component.html',
  styleUrls: ['./section.component.css']
})
export class SectionComponent implements OnInit {
  /************************* Variables ************************** */
  baseurl: string;
  _EmpCode: string;
  _PositionModule: number;

  LoadSection: SectionInfo[];
  txtSchSectionName: string;
  txtSchSectionCode: string;
  ddlSchPositionStatus: string;
  txtSectionCode: string;
  txtSectionName: string;
  txtExSectionName: string;
  txtExSectionCode: string;
  isOnUpdate: boolean;
  hidSectionId: number;
  element: HTMLElement;
  public hidcouchk: string;

  //Form variable
  positionForm: FormGroup;
  positionInfo: SectionInfo = new SectionInfo;

  //Pagination
  currentPageNumber: number = 1;
  totalPositions: number = 0;
  totalPages: number = 0;
  pageSize: number;
  public SectionTotal: any
  //Loading
  displayloading: boolean = false;
  Msgloadding: string = '';

  //Modal
  titlemodal: string;
  detailmodal: string;

  // Zone pagination variable
  isSubmitted: any;
  /************************* End Variables ************************** */
  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private GlobalService: GlobalService, private TokenService: TokenService) {
    this.baseurl = environment.base_api;
    GlobalService.CheckPagingAccessRights();
  }

  ngOnInit() {

    //Init data
    this.currentPageNumber = 1;
    this.pageSize = environment.PageSizeSmall;
    this._EmpCode = localStorage.getItem("EmpCode");
    this._PositionModule = ConstVariable.PositionProjectModule; //Project Delivery
    this.ddlSchPositionStatus = ''
    this.LSection();
    $(document).ready(function () {
      $('#InsertSectionSection').css('display', 'none');
    });

    //Load init data




    //Declare form
    this.positionForm = new FormGroup({
      //PositionCode: new FormControl(this.positionInfo.PositionCode, [Validators.required]),
      //PositionName: new FormControl(this.positionInfo.PositionName, [Validators.required]),
      //PositionLevel: new FormControl(this.positionInfo.PositionLevel, [Validators.required]),
      //PositionStatus: new FormControl(this.positionInfo.FlagActive),
      //FlagCreate: new FormControl(this.positionInfo.FlagCreate),
      //FlagEdit: new FormControl(this.positionInfo.FlagEdit),
      //FlagDeleteRights: new FormControl(this.positionInfo.FlagDeleteRights),
      //FlagApprove: new FormControl(this.positionInfo.FlagApprove),
      //FlagAssign: new FormControl(this.positionInfo.FlagAssign),
      //FlagView: new FormControl(this.positionInfo.FlagView),
    });
  }

  //get PositionCode() { return this.positionForm.get('PositionCode'); }
  //get PositionName() { return this.positionForm.get('PositionName'); }
  //get PositionLevel() { return this.positionForm.get('PositionLevel'); }


  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput

  }

  LSection() {
    this.LoadListSection()
      .then(
        data => {
          this.LoadSection = data
          this.hidcouchk = this.LoadSection.length.toString();
        }
      )
      .then(() => {
        this.CountSectionList()
      })
  }

  async CountSectionList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * environment.PageSize;


      let strjson = "{ \"SectionName\": \"" + this.checkUndefinedString(this.txtExSectionName) + "\", " +
        "\"CreateBy\": \"" + this.checkUndefinedString(localStorage.getItem("EmpCode")) + "\", " +
        "\"FlagDelete\": \"N\"" +
        "}";


      this.httpClient
        .post<SectionInfo[]>(this.baseurl + "Section/GetCountSection",
          strjson, httpOptions)
        .toPromise().then(data => {
          this.SectionTotal = data
        })
        .then(() => {
          if (this.SectionTotal == 0) {
            this.currentPageNumber = 1;
          }
          this.totalPages = Math.ceil(this.SectionTotal / environment.PageSize)
        })
    }
  }


  async LoadListSection(positionId: number = 0): Promise<SectionInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * environment.PageSize;

      var objectjson = {};
      objectjson['SectionName'] = this.checkUndefinedString(this.txtSchSectionName);
      objectjson['SectionCode'] = this.checkUndefinedString(this.txtSchSectionCode);
      //objectjson['CompanyCode'] = this.checkUndefinedString(this.txtSearchCompany);
      //objectjson['rowFetch'] = environment.PageSize;
      //objectjson['rowOFFSet'] = offset;
      //objectjson['FlagDelete'] = "N";

      let strjson = JSON.stringify(objectjson);

      console.log(strjson);

      return this.httpClient.post<SectionInfo[]>(this.baseurl + "Section/GetSection", strjson, httpOptions)
        .toPromise()

    }
  }

  OnSearch_Click() {
    this.currentPageNumber = 1;
    this.LoadListSection().then((data) => {
      this.LoadSection = data;
    });
  }
  OnClear_Click() {
    this.txtSchSectionName = null;
    this.txtSchSectionCode = null;
    this.txtExSectionName = null;
    this.txtExSectionCode = null; 

    this.currentPageNumber = 1;
    this.LoadListSection().then((data) => {
      this.LoadSection = data;
    });
  }

  //Create btn
  btnClick_onCreateSection() {

    $('#InsertSectionSection').css('display', 'block');

  }
  btnClick_cancel() {
    this.txtSchSectionName = null;
    this.txtSchSectionCode = null;
    this.txtExSectionName = null;
    this.txtExSectionCode = null;
    $('#InsertSectionSection').css('display', 'none');
  }


  OnCreating(flag) {
    if (flag == 'y') {
      $("#loadingcreate").show();
      $("#btnsubmitlookup").hide();
      $("#txtLookupType").prop('disabled', true);
      $("#txtLookupValue").prop('disabled', true);
      $('#btncloseicon').prop('disabled', true);
      $('#btnclose').prop('disabled', true);
    } else if (flag == 'n') {
      $("#loadingcreate").hide();
      $("#btnsubmitlookup").show();
      $("#txtLookupType").removeAttr('disabled');
      $("#txtLookupValue").removeAttr('disabled');
      $('#btncloseicon').removeAttr('disabled');
      $('#btnclose').removeAttr('disabled');
      $('#ModalLookup').modal('hide');
    }
  }


  async btnClick_submitInsertSection() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.OnCreating('y');
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };



      let strjson = "{" +
        "\"SectionCode\": \"" + this.checkUndefinedString(this.txtExSectionCode) + "\", " +
        "\"SectionName\": \"" + this.checkUndefinedString(this.txtExSectionName) + "\", " +
        "\"CreateBy\": \"" + this.checkUndefinedString(localStorage.getItem("EmpCode")) + "\", " +
        "\"FlagDelete\": \"N\"" +
        "}";

      this.isSubmitted = this.httpClient.post<LookupInfo[]>(this.baseurl + "Section/InsertSection", strjson, httpOptions)

        .subscribe(result => this.isSubmitted = result, failCb => {
          console.log("Insert fail")
          this.OnCreating('n');
        },
          () => {
            console.log("Insert = " + this.isSubmitted)
            this.OnClear_Click();
            //this.AuthorizeUser(this.ddlCompany + "0" + this.txtExEmpCode);

            //Inform user
            this.titlemodal = '';
            this.detailmodal = 'User information has been created successfully.';
            $('#ModalComplate .modal-header').text('Information');
            $('#ModalComplate .modal-header').addClass('bg-gold');
            $('#ModalComplate').modal();
            $('#InsertSectionSection').css('display', 'none');
            this.LSection()
          }
        );
    }
  }

  //Edit Function
  OnEdit_Click(id) {
    $('#InsertSectionSection').css('display', 'block');
    document.getElementById("AddEditSection").scrollIntoView();
    this.isOnUpdate = true


    let index = this.LoadSection.findIndex(x => x.SectionId == id);
    this.hidSectionId = this.LoadSection[index].SectionId
    this.txtExSectionCode = this.LoadSection[index].SectionCode
    this.txtExSectionName = this.LoadSection[index].SectionName

  }
  btnClick_submitUpdateSection(id) {
    $('#ModalConfirmChanges').modal();
  }
  async confirmSaveChanges() {
    $('#ModalConfirmChanges').modal('hide');
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {

      $('#InsertSectionSection').css('display', 'block');
      var id = this.hidSectionId
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };


      if (this.txtExSectionName == undefined || this.txtExSectionName == null || this.txtExSectionName == '') {
        alert("กรุณากรอกข้อมูลให้ครบถ้วน");
      }

      else if (this.txtExSectionCode == undefined || this.txtExSectionCode == null || this.txtExSectionCode == '') {
        alert("กรุณากรอกข้อมูลให้ครบถ้วน");
      }
      else {

        let objData = {};
        objData["SectionId"] = id;
        objData["SectionCode"] = this.txtExSectionCode;
        objData["SectionName"] = this.txtExSectionName;
        objData["UpdateBy"] = this.checkUndefinedString(localStorage.getItem("EmpCode"));
        objData["FlagDelete"] = "N";

        let strjson = JSON.stringify(objData);

        this.isSubmitted = this.httpClient.post<SectionInfo[]>(this.baseurl + "Section/UpdatSection", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Update fail")
          },
            () => {
              console.log("Update = " + this.isSubmitted)
              this.OnClear_Click();
              $('#InsertSectionSection').css('display', 'none');

              //Inform user
              this.titlemodal = '';
              this.detailmodal = 'User information has been updated successfully.';
              $('#ModalComplate .modal-header').text('Information');
              $('#ModalComplate .modal-header').addClass('bg-gold');
              $('#ModalComplate').modal();

              //Load new data
              this.LSection();
            }
          )
      }
    }
  }


  //Delete Function
  async OnDelete_Click(id) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      let strjsonCusInfo = "{SectionId: " + id + "}";

      if (confirm("Are you sure you want to delete this Section?")) {
        this.isSubmitted = this.httpClient.post<SectionInfo[]>(this.baseurl + "Section/DeleteSection", strjsonCusInfo, httpOptions)
          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Update fail")
          },
            () => {
              console.log("Update = " + this.isSubmitted)
              this.OnClear_Click();

              //Inform user
              this.titlemodal = '';
              this.detailmodal = 'Section information has been deleted successfully.';
              $('#ModalComplate .modal-header').text('Information');
              $('#ModalComplate .modal-header').addClass('bg-gold');
              $('#ModalComplate').modal();

              //Load new data
              this.LSection();
            }
          )
      }
    }

  }

  chkallclick(traget) {
    var check = $(traget.currentTarget).is(":checked");

    $('[name="checkboxSection"]').prop('checked', check);

  }

  async OnDeleteList_Click() {
    let num = parseInt(this.hidcouchk);
    for (var i = 0; i < num; i++) {
      var element = <HTMLInputElement>document.getElementById('chk' + i);
      var isChecked = element.checked;

      var element2 = <HTMLInputElement>document.getElementById('SectionId' + i);

      if (isChecked) {
        await this.OnDelete_Click(parseInt(element.value));
      }
    }
    //Load new data
    this.LSection();
  }

  //Name position clicked
  OnAddRights_Click(id) {

  }

  //Pagination
  OnLoadListFinished(traget = null) {
    if (traget != null) { // check call function from change page or onloadfrist
      this.currentPageNumber = traget.currentPageNumber;
      this.totalPages = traget.totalPages;
    }

    this.LoadListSection().then((data) => {
      this.LoadSection = data;
    });;
  }
  SetTotalpagePagination(data) {
    this.totalPositions = data;
    if (this.totalPositions == 0) this.currentPageNumber = 0;
    this.totalPages = Math.ceil(this.totalPositions / environment.PageSize);
  }

  //Private function
  private Loading(flag: boolean, Msg: string = '') {
    this.displayloading = flag;
    this.Msgloadding = Msg;
  }
  private markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

}
